 <ng-container #element></ng-container>